var v = (f, t, n) => {
  if (!t.has(f))
    throw TypeError("Cannot " + n);
};
var M = (f, t, n) => (v(f, t, "read from private field"), n ? n.call(f) : t.get(f)), V = (f, t, n) => {
  if (t.has(f))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(f) : t.set(f, n);
}, H = (f, t, n, g) => (v(f, t, "write to private field"), g ? g.call(f, n) : t.set(f, n), n);
function te(f, ...t) {
  return t.reduce((n, g) => (c) => n(g(c)), f);
}
function ne(f) {
  return typeof f == "object" && f !== null && !Array.isArray(f);
}
function re(f) {
  return {
    ...f,
    message: f.message,
    trace: (f.stack || "").split(/\n\s+/g)
  };
}
const ee = {
  OFF: 0,
  ERROR: 100,
  WARN: 200,
  LOG: 300,
  INFO: 400,
  DEBUG: 500,
  ALL: 600
}, ue = "ALL", ce = [{ transform: (f) => f }];
var J, q;
class Ae {
  constructor({ plugins: t, logLevel: n } = {}) {
    /**
     * List of transforms that will prepare the data
     * So it is logged to the right output with the right format
     */
    V(this, J, void 0);
    /**
     * The log level allowed for this instance.
     * Log levels follow the Log4J log level ranking.
     * See: https://logging.apache.org/log4j/2.x/manual/customloglevels.html
     */
    V(this, q, void 0);
    H(this, q, n || ue);
    const c = (t && t.length > 0 ? t : ce).map((E) => E.transform.bind(E)).reverse();
    H(this, J, te(...c));
  }
  /**
   * Write a 'info' level log, if the configured level allows for it.
   * Prints to `stdout` with newline.
   */
  info(t, n) {
    this.logIfEnabled(t, "INFO", n);
  }
  /**
   * Write an 'error' level log, if the configured level allows for it.
   * Prints to `stderr` with newline.
   */
  error(t, n) {
    this.logIfEnabled(t, "ERROR", n);
  }
  /**
   * Write a 'warn' level log, if the configured level allows for it.
   * Prints to `stdout` with newline.
   */
  warn(t, n) {
    this.logIfEnabled(t, "WARN", n);
  }
  /**
   * Write a 'debug' level log, if the configured level allows for it.
   * Prints to `stdout` with newline.
   */
  debug(t, n) {
    this.logIfEnabled(t, "DEBUG", n);
  }
  /**
   * Write a 'log' level log, if the configured level allows for it.
   * Prints to `stdout` with newline.
   */
  log(t, n) {
    this.logIfEnabled(t, "LOG", n);
  }
  logIfEnabled(t, n, g) {
    this.isLevelEnabled(n) && this.printMessages(t, n, g);
  }
  isLevelEnabled(t) {
    return ee[t] <= ee[M(this, q)];
  }
  prepareMessage(t, n, g) {
    let c = g;
    return c instanceof Error && (c = re(c)), typeof c == "string" && (c = { message: c }), M(this, J).call(this, {
      data: { logId: n, ...c },
      config: { level: t }
    });
  }
  printMessages(t, n, g) {
    const { data: c } = this.prepareMessage(n, t, g);
    switch (n) {
      case "ERROR":
        return console.error(c);
      case "DEBUG":
        return console.debug(c);
      case "LOG":
        return console.log(c);
      case "INFO":
        return console.info(c);
      case "WARN":
        return console.warn(c);
      default:
        return;
    }
  }
}
J = new WeakMap(), q = new WeakMap();
const ge = "UNSAFE_FIELD_OBFUSCATED", le = [
  // `cert` isn't unsafe from a data point of view, but it spams the logs
  // very heavily, so we shouldn't log it
  "cert",
  "fullName",
  "password",
  "passwordPlain",
  "pin",
  "oldPassword",
  "newPassword",
  "transactionPin",
  "newTransactionPin",
  "newTransactionPinRepeat",
  "iban",
  "partnerIban",
  "bic",
  "partnerBic",
  "cardToken",
  "zipCode",
  "publicToken",
  "email",
  "phoneNumber",
  "emailOrPhone",
  "partnerName",
  "partnerAccountNumber",
  "partnerName",
  "street",
  "number",
  "idNumber",
  "taxNumber",
  "newPinConfirm",
  "newPin",
  "newPinRepeat",
  "idExpiryDateMonth",
  "idExpiryDateYear",
  "firstName",
  "lastName",
  "documentNumber",
  "dob",
  "surname",
  "birthDate",
  "mobilePhoneNumber",
  "to",
  "stripe-signature",
  "birthDateDay",
  "birthDateMonth",
  "birthDateYear",
  "socialSecurityNumber",
  "middleName",
  "shippingAddress_street",
  "shippingAddress_number",
  "legalAddress_number",
  "legalAddress_street",
  "taxNumbers",
  "issue_incidentLocation",
  "issue_incidentDescription",
  "referenceText"
];
function de(f) {
  const t = { ...f };
  return le.forEach((n) => {
    n in t && (t[n] = ge);
  }), t;
}
const me = "UNSAFE_HEADER_VALUE_OBFUSCATED";
function he(f) {
  return `UNSAFE_${f}_OBFUSCATED`;
}
function pe(f) {
  const t = f.map((c) => ({
    displayName: c,
    name: process.env[c]
  })), g = [
    "Authorization",
    "x-vault-token",
    "encrypted-pin",
    "encrypted-secret",
    "AccessKeyId",
    "SecretAccessKey",
    ...f.map((c) => process.env[c])
  ];
  return function(E) {
    const w = { ...E };
    return g.forEach((_) => {
      _ && _ in w && (w[_] = me);
    }), t.forEach(({ displayName: _, name: L }) => {
      L && L in w && (w[he(_)] = w[L], delete w[L]);
    }), w;
  };
}
var G, B;
class Ne {
  /**
   * @param {object} options
   * @param {boolean} options.enabled
   * @param {Array<string>} options.customHeaders
   * @param {number} options.depth
   * */
  constructor(t = {}) {
    V(this, G, void 0);
    V(this, B, void 0);
    H(this, G, t.depth || 5), H(this, B, te(de, pe(t.customHeaders || [])));
  }
  obfuscate(t, n = 0) {
    const g = M(this, B).call(this, t);
    return n++ >= M(this, G) ? g : Object.keys(g).reduce(
      (c, E) => (c[E] = ne(g[E]) ? this.obfuscate(g[E], n + 1) : g[E], c),
      {}
    );
  }
  transform(t) {
    return {
      data: this.obfuscate(t.data),
      config: t.config
    };
  }
}
G = new WeakMap(), B = new WeakMap();
const ae = [
  "Accept",
  "Cache-Control",
  "Connection",
  "Content-Length",
  "Content-Type",
  "Pragma",
  "Server",
  "User-Agent",
  "X-Content-Type-Options",
  "x-datadog-sampled",
  "x-datadog-sampling-priority",
  "X-Frame-Options",
  "X-XSS-Protection"
];
class Oe {
  /**
   * @param {object} options
   * @param {boolean} options.sanitizeConfig
   * */
  constructor(t = {}) {
    this.sanitizeConfig = t.sanitizeConfig ?? !0;
  }
  transform(t) {
    var _, L, I, K;
    if (!((_ = t == null ? void 0 : t.data) != null && _.isAxiosError) || !(t != null && t.data))
      return t;
    const n = { ...t == null ? void 0 : t.data }, g = (I = (L = n.request) == null ? void 0 : L.headers) == null ? void 0 : I["x-request-id"];
    n.response && (delete n.response.config, delete n.response.request, delete n.response.headers), delete n.request, delete n.toJSON, n.config && (delete n.config.adapter, delete n.config.transformRequest, delete n.config.transformResponse, delete n.config.validateStatus, delete n.config.xsrfCookieName, delete n.config.xsrfHeaderName, delete n.config.maxBodyLength, delete n.config.maxContentLength, delete n.config.timeout, n.config.headers && ae.forEach((z) => {
      delete n.config.headers[z];
    })), g && (n.request = {
      headers: {
        "x-request-id": g
      }
    }), this.sanitizeConfig && n.config && delete n.config.data;
    let c = t.config.level;
    const E = ((K = n.response) == null ? void 0 : K.status) || "";
    return String(E).startsWith("5") && c !== "error" && (console.log("LOG_SEVERITY_INCREASE", {
      log: n.logName,
      level: c,
      message: "Failing with HTTP 500; bumping log severity."
    }), c = "error"), {
      data: n,
      config: { ...t.config, level: c }
    };
  }
}
function ye(f) {
  return f && f.__esModule && Object.prototype.hasOwnProperty.call(f, "default") ? f.default : f;
}
var Z = { exports: {} };
(function(f, t) {
  const { hasOwnProperty: n } = Object.prototype, g = Q();
  g.configure = Q, g.stringify = g, g.default = g, t.stringify = g, t.configure = Q, f.exports = g;
  const c = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]|[\ud800-\udbff](?![\udc00-\udfff])|(?:[^\ud800-\udbff]|^)[\udc00-\udfff]/;
  function E(r) {
    return r.length < 5e3 && !c.test(r) ? `"${r}"` : JSON.stringify(r);
  }
  function w(r) {
    if (r.length > 200)
      return r.sort();
    for (let o = 1; o < r.length; o++) {
      const m = r[o];
      let A = o;
      for (; A !== 0 && r[A - 1] > m; )
        r[A] = r[A - 1], A--;
      r[A] = m;
    }
    return r;
  }
  const _ = Object.getOwnPropertyDescriptor(
    Object.getPrototypeOf(
      Object.getPrototypeOf(
        new Int8Array()
      )
    ),
    Symbol.toStringTag
  ).get;
  function L(r) {
    return _.call(r) !== void 0 && r.length !== 0;
  }
  function I(r, o, m) {
    r.length < m && (m = r.length);
    const A = o === "," ? "" : " ";
    let j = `"0":${A}${r[0]}`;
    for (let R = 1; R < m; R++)
      j += `${o}"${R}":${A}${r[R]}`;
    return j;
  }
  function K(r) {
    if (n.call(r, "circularValue")) {
      const o = r.circularValue;
      if (typeof o == "string")
        return `"${o}"`;
      if (o == null)
        return o;
      if (o === Error || o === TypeError)
        return {
          toString() {
            throw new TypeError("Converting circular structure to JSON");
          }
        };
      throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined');
    }
    return '"[Circular]"';
  }
  function z(r, o) {
    let m;
    if (n.call(r, o) && (m = r[o], typeof m != "boolean"))
      throw new TypeError(`The "${o}" argument must be of type boolean`);
    return m === void 0 ? !0 : m;
  }
  function k(r, o) {
    let m;
    if (n.call(r, o)) {
      if (m = r[o], typeof m != "number")
        throw new TypeError(`The "${o}" argument must be of type number`);
      if (!Number.isInteger(m))
        throw new TypeError(`The "${o}" argument must be an integer`);
      if (m < 1)
        throw new RangeError(`The "${o}" argument must be >= 1`);
    }
    return m === void 0 ? 1 / 0 : m;
  }
  function P(r) {
    return r === 1 ? "1 item" : `${r} items`;
  }
  function oe(r) {
    const o = /* @__PURE__ */ new Set();
    for (const m of r)
      (typeof m == "string" || typeof m == "number") && o.add(String(m));
    return o;
  }
  function fe(r) {
    if (n.call(r, "strict")) {
      const o = r.strict;
      if (typeof o != "boolean")
        throw new TypeError('The "strict" argument must be of type boolean');
      if (o)
        return (m) => {
          let A = `Object can not safely be stringified. Received type ${typeof m}`;
          throw typeof m != "function" && (A += ` (${m.toString()})`), new Error(A);
        };
    }
  }
  function Q(r) {
    r = { ...r };
    const o = fe(r);
    o && (r.bigint === void 0 && (r.bigint = !1), "circularValue" in r || (r.circularValue = Error));
    const m = K(r), A = z(r, "bigint"), j = z(r, "deterministic"), R = k(r, "maximumDepth"), y = k(r, "maximumBreadth");
    function W(N, e, i, l, u, h) {
      let s = e[N];
      switch (typeof s == "object" && s !== null && typeof s.toJSON == "function" && (s = s.toJSON(N)), s = l.call(e, N, s), typeof s) {
        case "string":
          return E(s);
        case "object": {
          if (s === null)
            return "null";
          if (i.indexOf(s) !== -1)
            return m;
          let d = "", a = ",";
          const b = h;
          if (Array.isArray(s)) {
            if (s.length === 0)
              return "[]";
            if (R < i.length + 1)
              return '"[Array]"';
            i.push(s), u !== "" && (h += u, d += `
${h}`, a = `,
${h}`);
            const T = Math.min(s.length, y);
            let D = 0;
            for (; D < T - 1; D++) {
              const Y = W(String(D), s, i, l, u, h);
              d += Y !== void 0 ? Y : "null", d += a;
            }
            const F = W(String(D), s, i, l, u, h);
            if (d += F !== void 0 ? F : "null", s.length - 1 > y) {
              const Y = s.length - y - 1;
              d += `${a}"... ${P(Y)} not stringified"`;
            }
            return u !== "" && (d += `
${b}`), i.pop(), `[${d}]`;
          }
          let S = Object.keys(s);
          const $ = S.length;
          if ($ === 0)
            return "{}";
          if (R < i.length + 1)
            return '"[Object]"';
          let p = "", O = "";
          u !== "" && (h += u, a = `,
${h}`, p = " ");
          const x = Math.min($, y);
          j && !L(s) && (S = w(S)), i.push(s);
          for (let T = 0; T < x; T++) {
            const D = S[T], F = W(D, s, i, l, u, h);
            F !== void 0 && (d += `${O}${E(D)}:${p}${F}`, O = a);
          }
          if ($ > y) {
            const T = $ - y;
            d += `${O}"...":${p}"${P(T)} not stringified"`, O = a;
          }
          return u !== "" && O.length > 1 && (d = `
${h}${d}
${b}`), i.pop(), `{${d}}`;
        }
        case "number":
          return isFinite(s) ? String(s) : o ? o(s) : "null";
        case "boolean":
          return s === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (A)
            return String(s);
        default:
          return o ? o(s) : void 0;
      }
    }
    function X(N, e, i, l, u, h) {
      switch (typeof e == "object" && e !== null && typeof e.toJSON == "function" && (e = e.toJSON(N)), typeof e) {
        case "string":
          return E(e);
        case "object": {
          if (e === null)
            return "null";
          if (i.indexOf(e) !== -1)
            return m;
          const s = h;
          let d = "", a = ",";
          if (Array.isArray(e)) {
            if (e.length === 0)
              return "[]";
            if (R < i.length + 1)
              return '"[Array]"';
            i.push(e), u !== "" && (h += u, d += `
${h}`, a = `,
${h}`);
            const $ = Math.min(e.length, y);
            let p = 0;
            for (; p < $ - 1; p++) {
              const x = X(String(p), e[p], i, l, u, h);
              d += x !== void 0 ? x : "null", d += a;
            }
            const O = X(String(p), e[p], i, l, u, h);
            if (d += O !== void 0 ? O : "null", e.length - 1 > y) {
              const x = e.length - y - 1;
              d += `${a}"... ${P(x)} not stringified"`;
            }
            return u !== "" && (d += `
${s}`), i.pop(), `[${d}]`;
          }
          i.push(e);
          let b = "";
          u !== "" && (h += u, a = `,
${h}`, b = " ");
          let S = "";
          for (const $ of l) {
            const p = X($, e[$], i, l, u, h);
            p !== void 0 && (d += `${S}${E($)}:${b}${p}`, S = a);
          }
          return u !== "" && S.length > 1 && (d = `
${h}${d}
${s}`), i.pop(), `{${d}}`;
        }
        case "number":
          return isFinite(e) ? String(e) : o ? o(e) : "null";
        case "boolean":
          return e === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (A)
            return String(e);
        default:
          return o ? o(e) : void 0;
      }
    }
    function C(N, e, i, l, u) {
      switch (typeof e) {
        case "string":
          return E(e);
        case "object": {
          if (e === null)
            return "null";
          if (typeof e.toJSON == "function") {
            if (e = e.toJSON(N), typeof e != "object")
              return C(N, e, i, l, u);
            if (e === null)
              return "null";
          }
          if (i.indexOf(e) !== -1)
            return m;
          const h = u;
          if (Array.isArray(e)) {
            if (e.length === 0)
              return "[]";
            if (R < i.length + 1)
              return '"[Array]"';
            i.push(e), u += l;
            let p = `
${u}`;
            const O = `,
${u}`, x = Math.min(e.length, y);
            let T = 0;
            for (; T < x - 1; T++) {
              const F = C(String(T), e[T], i, l, u);
              p += F !== void 0 ? F : "null", p += O;
            }
            const D = C(String(T), e[T], i, l, u);
            if (p += D !== void 0 ? D : "null", e.length - 1 > y) {
              const F = e.length - y - 1;
              p += `${O}"... ${P(F)} not stringified"`;
            }
            return p += `
${h}`, i.pop(), `[${p}]`;
          }
          let s = Object.keys(e);
          const d = s.length;
          if (d === 0)
            return "{}";
          if (R < i.length + 1)
            return '"[Object]"';
          u += l;
          const a = `,
${u}`;
          let b = "", S = "", $ = Math.min(d, y);
          L(e) && (b += I(e, a, y), s = s.slice(e.length), $ -= e.length, S = a), j && (s = w(s)), i.push(e);
          for (let p = 0; p < $; p++) {
            const O = s[p], x = C(O, e[O], i, l, u);
            x !== void 0 && (b += `${S}${E(O)}: ${x}`, S = a);
          }
          if (d > y) {
            const p = d - y;
            b += `${S}"...": "${P(p)} not stringified"`, S = a;
          }
          return S !== "" && (b = `
${u}${b}
${h}`), i.pop(), `{${b}}`;
        }
        case "number":
          return isFinite(e) ? String(e) : o ? o(e) : "null";
        case "boolean":
          return e === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (A)
            return String(e);
        default:
          return o ? o(e) : void 0;
      }
    }
    function U(N, e, i) {
      switch (typeof e) {
        case "string":
          return E(e);
        case "object": {
          if (e === null)
            return "null";
          if (typeof e.toJSON == "function") {
            if (e = e.toJSON(N), typeof e != "object")
              return U(N, e, i);
            if (e === null)
              return "null";
          }
          if (i.indexOf(e) !== -1)
            return m;
          let l = "";
          if (Array.isArray(e)) {
            if (e.length === 0)
              return "[]";
            if (R < i.length + 1)
              return '"[Array]"';
            i.push(e);
            const a = Math.min(e.length, y);
            let b = 0;
            for (; b < a - 1; b++) {
              const $ = U(String(b), e[b], i);
              l += $ !== void 0 ? $ : "null", l += ",";
            }
            const S = U(String(b), e[b], i);
            if (l += S !== void 0 ? S : "null", e.length - 1 > y) {
              const $ = e.length - y - 1;
              l += `,"... ${P($)} not stringified"`;
            }
            return i.pop(), `[${l}]`;
          }
          let u = Object.keys(e);
          const h = u.length;
          if (h === 0)
            return "{}";
          if (R < i.length + 1)
            return '"[Object]"';
          let s = "", d = Math.min(h, y);
          L(e) && (l += I(e, ",", y), u = u.slice(e.length), d -= e.length, s = ","), j && (u = w(u)), i.push(e);
          for (let a = 0; a < d; a++) {
            const b = u[a], S = U(b, e[b], i);
            S !== void 0 && (l += `${s}${E(b)}:${S}`, s = ",");
          }
          if (h > y) {
            const a = h - y;
            l += `${s}"...":"${P(a)} not stringified"`;
          }
          return i.pop(), `{${l}}`;
        }
        case "number":
          return isFinite(e) ? String(e) : o ? o(e) : "null";
        case "boolean":
          return e === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (A)
            return String(e);
        default:
          return o ? o(e) : void 0;
      }
    }
    function se(N, e, i) {
      if (arguments.length > 1) {
        let l = "";
        if (typeof i == "number" ? l = " ".repeat(Math.min(i, 10)) : typeof i == "string" && (l = i.slice(0, 10)), e != null) {
          if (typeof e == "function")
            return W("", { "": N }, [], e, l, "");
          if (Array.isArray(e))
            return X("", N, [], oe(e), l, "");
        }
        if (l.length !== 0)
          return C("", N, [], l, "");
      }
      return U("", N, []);
    }
    return se;
  }
})(Z, Z.exports);
var be = Z.exports;
const ie = /* @__PURE__ */ ye(be);
ie.configure;
function Ee(f, t) {
  return t instanceof Error ? re(t) : t;
}
const Se = ie.configure({
  deterministic: !1
});
class we {
  /**
   * Formatter plugin to transform log lines into the N26 expected format
   * so log lines can be processed by Logstash and discovered in OpenSearch.
   * See: https://sredocs.tech26.de/logging/logging_pattern/
   *
   * @param serviceName Service name that will identify your logs on the `service-*` index in Open search
   */
  constructor(t) {
    this.serviceName = t;
  }
  transform(t) {
    const { config: n, data: g } = t, { level: c } = n, E = (/* @__PURE__ */ new Date()).toISOString(), w = c.toUpperCase(), _ = ne(g) ? Se(g, Ee) : g;
    return {
      data: `[n26/${this.serviceName}] [${E}] [${w}] [main] [] ${_}`,
      config: t.config
    };
  }
}
export {
  Oe as AxiosCleanerPlugin,
  we as N26FormatterPlugin,
  Ae as N26Logger,
  Ne as ObfuscaterPlugin
};
//# sourceMappingURL=index.js.map
